<fgb-page-header [pageTitle]="'rewards.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<fgb-banner [bannerTitle]="'mixed.nav.raffles' | translate"></fgb-banner>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container mt-3">
  <fgbcl-lottos-list-v2 [isList]="true" [defaultSort]="1"></fgbcl-lottos-list-v2>
</div>
